export const appConfig = {
    instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY,
    endpointUrl: process.env.REACT_APP_ENDPOINT_URL,
};
